import React from 'react'
import {Layout,Menu,Drawer,Icon,Button,notification} from 'antd'
import {BrowserRouter as Router,Route,Switch,Link} from 'react-router-dom'
import Constant from './Constant'
import Background from './Background'
import Breadcrumb from './Breadcrumb'
import Container from './Container'
import Flag from './flag/Flag'
//import Home from './page/Home'
import Home from './cms/Home'
import * as API from './cms/API'
import {withNamespaces} from 'react-i18next'
import i18n from '../i18n'

class Main extends React.Component {
  state={
    //country: Constant.countries[0].key,
  }
  componentDidMount() {
    // show cookies notification on startup for the first time
    if (!localStorage.getItem(Constant.key.cookie)) {
      this.openNotification()
    }
    this.update()
    this.initBackground()
    //this.initBackgroundImage()
  }
  update(cb) {
    const key = Constant.key.lastUpdated
    const lastUpdated = localStorage.getItem(key)
    if (!lastUpdated) {
      localStorage.clear()
    }
    API.update(data=>{
      if (typeof(data)==='string'&&data.length>0) {
        const n = parseInt(data)
        if (typeof(n)==='number'&&n>0) {
          if (data!==lastUpdated) {
            localStorage.clear()
            localStorage.setItem(key,data)
            if (typeof(cb)==='function') cb()
            return
          }
        }
      }
    }, e=>{
      localStorage.clear()
      if (typeof(cb)==='function') cb()
    })
  }
  initBackground() {
    const {backgrounds} = Constant
    if (Array.isArray(backgrounds)&&backgrounds.length>0) {
      const background = localStorage.getItem(Constant.key.background)
      if (typeof(background)==='string' && background.length>0) {
        this.setState({background})
      } else {
        const index = Math.floor(Math.random()*backgrounds.length)
        if (typeof(backgrounds[index])==='string' && backgrounds[index].length>0) {
          this.setState({background:backgrounds[index]})
        }
      }
    }
  }
  initBackgroundImage() {
    const {backgroundImages} = Constant
    const {length} = backgroundImages
    const backgroundImageIndex = Math.floor(Math.random()*length)
    this.setState({backgroundImageIndex},this.changeBackgroundImage)
  }
  changeBackgroundImage=()=>{
    setTimeout(()=>{
      const {backgroundImageIndex} = this.state
      const {backgroundImages} = Constant
      const {length} = backgroundImages
      const index = backgroundImageIndex<length-1?backgroundImageIndex+1:0
      this.setState({backgroundImageIndex:index}, this.changeBackgroundImage)
    },10000)
  }
  onCloseNotification=()=>{
    localStorage.setItem(Constant.key.cookie, true)
  }
  openNotification=()=>{
    const {t} = this.props
    const style = {
      width: '100%',
    }
    //const key = `notification-${Date.now()}`
    const key = Constant.key.cookie
    const btn = (
      <Button type="primary" size="small" onClick={()=>{
        notification.close(key)
        this.onCloseNotification()
      }}>{t('cookie:Accept')}</Button>
    )
    const {name} = Constant
    // TODO: link to Privacy Policy
    const description = t('cookie:message',{name})
    notification.config({placement:'bottomLeft'}) // other placement options: topRight, bottomRight, bottomLeft, topLeft
    notification.open({
      message: '',
      description,
      duration: 0, // never close automatically
      style,
      btn,
      key,
    })
  }
  renderLogo() {
    const {name} = Constant
    return (
      <Link to="/">
        <div className="logo-container">
          {/*<div className="logo" />*/}
          <span className="logo-name">{'\u{1f984}'} {name}</span>
        </div>
      </Link>
    )
  }
  renderNavbar() {
    // defaultSelectedKeys={['2']}
    //const {t} = this.props
    return (
      <Layout.Header className="layout-header box-shadow">
        {this.renderLogo()}
        <Menu
          theme="light"
          mode="horizontal"
          style={{ lineHeight: '64px' }}
        >
          <Menu.Item key="toggle" className="float-right" onClick={this.openDrawer}>
            <Icon type="bars" />{/*'\u2630'*/}
          </Menu.Item>
        </Menu>
      </Layout.Header>
    )
  }
  openDrawer=()=>{this.setState({drawer:true})}
  closeDrawer=()=>{this.setState({drawer:false})}
  renderDrawer() {
    const {t} = this.props
    const {drawer} = this.state
    return (
      <Drawer
        title={t(`home:Menu`)}
        placement="right"
        closable
        onClose={this.closeDrawer}
        visible={drawer}
      >
        {this.renderNavMenu()}
        {/*this.renderCountryMenu()*/}
        {this.renderLanguageMenu()}
        {this.renderBackgroundMenu()}
      </Drawer>
    )
  }
  reload=()=>{
    this.setState({reloading:true},()=>{
      this.setState({reloading:false})
    })
  }
  renderNavMenu() {
    const {t} = this.props
    const {navs} = Constant
    return (
      <Menu mode="inline" defaultOpenKeys={['nav']} className="border-bottom">
        <Menu.SubMenu key="nav" title={<span><Icon type="select" /><span>{t('settings:Navigate to')}</span></span>}>
          <Menu.Item key="">
            <Link to="/">{t(`key:home`)}</Link>
          </Menu.Item>
          {
            navs.map((e,i)=>{
              const {key} = e
              const className = ''//country===key?'ant-menu-item-selected':''
              return (
                <Menu.Item key={key} className={className}>
                  <Link to={`/${key}`}>{t(`key:${key}`)}</Link>
                </Menu.Item>
              )
            })
          }
        </Menu.SubMenu>
      </Menu>
    )
  }
  renderCountryMenu() {
    const {t} = this.props
    const {countries} = Constant
    const country = localStorage.getItem(Constant.key.country)
    return (
      <Menu mode="inline" defaultOpenKeys={['changeCountry']} className="border-bottom">
        <Menu.SubMenu key="changeCountry" title={<span><Icon type="global" /><span>{t('settings:changeCountry')}</span></span>}>
          {
            countries.map((e,i)=>{
              const {key} = e
              const className = country===key?'ant-menu-item-selected':''
              return (
                <Menu.Item key={key} onClick={()=>{
                  localStorage.setItem(Constant.key.country,key)
                  this.reload()
                }} className={className}><Flag code={key} className="mr-2" />{t(`countries:${key}`)}</Menu.Item>
              )
            })
          }
        </Menu.SubMenu>
      </Menu>
    )
  }
  changeBackground=e=>{
    if (typeof(e)==='string'&&e.length>0) {
      localStorage.setItem(Constant.key.background,e)
      window.location.reload()
      //this.setState({background:e})
      /*this.setState((prevState,props)=>{
        delete prevState.background
        return prevState
      },()=>{
        this.setState({background:e})
      })*/
    }
  }
  changeLanguage=code=>{
    if (typeof(code)==='string'&&code.length>0) {
      i18n.changeLanguage(code)
      this.onLanguageChange()
    }
  }
  onLanguageChange=()=>{
    const key = Constant.key.cookie
    if (!localStorage.getItem(key)) {
      notification.close(key)
      this.openNotification()
    }
  }
  renderLanguageMenu() {
    const {t} = this.props
    const {languages} = Constant
    const {language} = i18n
    return (
      <Menu mode="inline" defaultOpenKeys={['changeLanguage']}  className="border-bottom">
        <Menu.SubMenu key="changeLanguage" title={<span><Icon type="sound" /><span>{t('settings:changeLanguage')}</span></span>}>
          {
            languages.map((e,i)=>{
              const {key,code} = e
              const className = code===language?'ant-menu-item-selected':''
              return (
                <Menu.Item key={key} onClick={()=>this.changeLanguage(code)} className={className}>{t(`languages:${key}`)}</Menu.Item>
              )
            })
          }
        </Menu.SubMenu>
      </Menu>
    )
  }
  renderBackgroundMenu() {
    const {t} = this.props
    const {backgrounds} = Constant
    const background = localStorage.getItem(Constant.key.background)
    return (
      <Menu mode="inline" defaultOpenKeys={['changeBackground']}  className="border-bottom">
        <Menu.SubMenu key="changeBackground" title={<span><Icon type="picture" /><span>{t('settings:changeBackground')}</span></span>}>
          {
            backgrounds.map((e,i)=>{
              const className = e===background?'ant-menu-item-selected':''
              return (
                <Menu.Item key={e} onClick={()=>this.changeBackground(e)} className={className}>{t(`backgrounds:${e}`)}</Menu.Item>
              )
            })
          }
        </Menu.SubMenu>
      </Menu>
    )
  }
  renderFooter() {
    const {t} = this.props
    const {name,by} = Constant
    const year = (new Date()).getFullYear()
    const copyright = t(`home:copyright`,{year,name,by})
    return (
      <Layout.Footer className="text-center">{copyright}</Layout.Footer>
    )
  }
  renderBreadcrumb() {
    /*return (
      <Breadcrumb style={{ margin: '16px 0' }}>
        <Breadcrumb.Item>Home</Breadcrumb.Item>
        <Breadcrumb.Item>List</Breadcrumb.Item>
        <Breadcrumb.Item>App</Breadcrumb.Item>
      </Breadcrumb>
    )*/
    return (
      <Switch>
        <Route path="/:key/:slug" component={Breadcrumb} />
        <Route path="/:key" component={Breadcrumb} />
        {
          // hide breadcrumb at home
          //<Route path="/" component={Breadcrumb} />
        }
      </Switch>
    )
  }
  renderContentContainer() {
    const {reloading} = this.state
    if (reloading) return null
    return (
      <Layout.Content className="main-container">
        {/*this.renderBreadcrumb()*/}
        {this.renderContent()}
      </Layout.Content>
    )
  }
  renderContent() {
    /*return (
      <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>Content</div>
    )*/
    return (
      <Switch>
        {/*
          <Route path="/:key" component={Container} />
          <Route path="/:key/:key" component={Container} />
          <Route path="/" component={Home} />
        */}
        <Route path="/:key/:slug" component={Container} />
        <Route path="/:key" component={Container} />
        <Route path="/" component={Home} />
      </Switch>
    )
  }
  style=()=>{
    /*const {backgroundImages} = Constant
    const {backgroundImageIndex} = this.state
    if (typeof(backgroundImageIndex)==='number'&&backgroundImageIndex>=0&&backgroundImageIndex<backgroundImages.length) {
      const backgroundImage = Constant.backgroundImages[backgroundImageIndex]
      return {
        backgroundImage:`url(${backgroundImage})`,
        //backgroundSize: 'cover',
        //transition: `background-image 5s ease-in-out`,
      }
    }*/
    return {}
  }
  render() {
    return (
      <Router>
        <Layout className="layout" style={this.style()}>
          <Background value={this.state.background} />
          {this.renderNavbar()}
          {this.renderDrawer()}
          {this.renderContentContainer()}
          {this.renderFooter()}
        </Layout>
      </Router>
    )
  }
}
export default withNamespaces('translations')(Main)
